import { DefaultState } from 'store/types';

export const POST_AUTOMATED_REPORT_REQUEST = 'POST_AUTOMATED_REPORT_REQUEST';
export const POST_AUTOMATED_REPORT_SUCCESS = 'POST_AUTOMATED_REPORT_SUCCESS';
export const POST_AUTOMATED_REPORT_FAILURE = 'POST_AUTOMATED_REPORT_FAILURE';

export interface AutomatedReportFrequencyParams {
  days: string[];
  time: string;
}

export interface AutomatedReportForm {
  id?: string;
  reportType: string;
  requestedDates: string;
  recipientsEmails: string[];
  weekDays: string[];
  sendTime: string;
}

export interface PostAutomatedReportRow {
  id: string;
  reportType: string;
  requestedDates: string;
  recipientsEmails: string[];
  weekDays: string[];
  sendTime: string;
}

export interface PostAutomatedReportData {
  rows: PostAutomatedReportRow[];
  totalCount: number;
}

export type PostAutomatedReportState = DefaultState & {
  contents?: PostAutomatedReportData;
};

interface PostAutomatedReportRequest {
  type: typeof POST_AUTOMATED_REPORT_REQUEST;
}

interface PostAutomatedReportSuccess {
  type: typeof POST_AUTOMATED_REPORT_SUCCESS;
  contents: PostAutomatedReportData;
}

interface PostAutomatedReportFailure {
  type: typeof POST_AUTOMATED_REPORT_FAILURE;
}

export type PostAutomatedReportActionTypes = PostAutomatedReportRequest | PostAutomatedReportSuccess | PostAutomatedReportFailure;